import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function stripeCheckout(params) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/checkout/stripe`, params, options)
    .then((res) => {
      return res.data;
    });
}

function stripePaymentIntent(params) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };
  return axios
    .post(`${url}/user/checkout/stripeIntent`, params, options)
    .then((res) => {
      return res.data;
    });
}

function stripePaymentIntentUpdate(params) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/checkout/stripeIntentUpdate`, params, options)
    .then((res) => {
      return res.data;
    });
}

export default {
  stripeCheckout,
  stripePaymentIntent,
  stripePaymentIntentUpdate
};
